import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthInterceptor } from './services/http/auth.interceptor';
import { TimeoutInterceptor } from './services/http/timeout.interceptor';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

// Registrar localização para português brasileiro
registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    provideHttpClient(
      withFetch(),
      withInterceptors([TimeoutInterceptor, AuthInterceptor])
    ),
    provideAnimationsAsync(),
    provideOAuthClient(),
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ]
};